import { render, staticRenderFns } from "./foto-pessoa.vue?vue&type=template&id=56cccb52&scoped=true"
import script from "./foto-pessoa.vue?vue&type=script&lang=js"
export * from "./foto-pessoa.vue?vue&type=script&lang=js"
import style0 from "./foto-pessoa.vue?vue&type=style&index=0&id=56cccb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cccb52",
  null
  
)

export default component.exports